export default __webpack_public_path__ + "static/media/mobile_video_call.cfbd11c0.png";